module.exports = __webpack_public_path__ + "img/kids-forest-lg-1x.2bcd41b2.jpg";